import { render, staticRenderFns } from "./Tool.vue?vue&type=template&id=4b4d561a&scoped=true&"
import script from "./Tool.vue?vue&type=script&lang=js&"
export * from "./Tool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d561a",
  null
  
)

export default component.exports